import { createSlice } from "@reduxjs/toolkit";
import { signInAction } from "../actions/signIn.action";
import { initialStateInterface } from "../interfaces/interface";
import { signOutAction } from "../actions/signOut.action";


const initialState: initialStateInterface = {
  isLoading: false,
  error: null,
  isError: false,
  user:null,
  isSuccess: false
} 

const SignInSlice = createSlice({
  name: "signInSlice",

  initialState,

  reducers: {
      resetState: (state) => {
        state.isLoading = false,
        state.error = null,
        state.isError = false,
        state.user = null,
        state.isSuccess = false
      }
  },

  extraReducers: (builder) => {
    builder
      .addCase(signInAction.fulfilled, (state, action) => {
        state.isLoading = false;
        state.user = action.payload;
        state.error = null;
        state.isSuccess = true;
        state.isError = false;
      })

      .addCase(signInAction.pending, (state) => {
        state.isLoading = true;
      })

      .addCase(signInAction.rejected, (state, action) => {
        state.isLoading = false;
        state.user = null;
        state.error = action.error.message;
        state.isError = true;
      })
      .addCase(signOutAction.fulfilled, (state, ) => {
        state.isLoading = false;
        state.user = null;
        state.error = null;
        state.isSuccess = true;
        state.isError = false;
      })

      .addCase(signOutAction.pending, (state) => {
        state.isLoading = false;
        state.isLoading = true;
      })

      .addCase(signOutAction.rejected, (state, action) => {
        state.isLoading = false;
        state.user = null;
        state.error = action.error.message;
        state.isError = true;
      })
  },
});

export const { resetState } = SignInSlice.actions;
export default SignInSlice.reducer;
